import { Button, Divider, Flex, HStack, Text } from '@chakra-ui/react'
import { BlockContainer, BlockHeader } from '../components/shared/Block'
import { BsPencilSquare, BsUnlock, BsPersonSquare } from 'react-icons/bs'
import ProfileInfo from '../components/profile/ProfileInfo'
import { useEffect, useState } from 'react'
import ProfileEdit from '../components/profile/ProfileEdit'
import ProfileEditPassword from '../components/profile/ProfileEditPassword'
import { useLocation } from 'react-router-dom'

const Profile = () => {
    const [menu, setMenu] = useState(1)
    const query = new URLSearchParams(useLocation().search)
    const menuq = query.get("menu")

    useEffect(() => {
        if (menuq) {
            // console.log(menuq)
            setMenu(parseInt(menuq))
        }
    }, [menuq])

    const headerName = () => {
        switch (menu) {
            case 1: return "ข้อมูลบัญชีผู้ใช้"
            case 2: return "แก้ไขข้อมูลบัญชีผู้ใช้"
            case 3: return "แก้ไขรหัสผ่าน"
            default: return "ข้อมูลบัญชีผู้ใช้"
        }
    }
    const headerIcon = () => {
        switch (menu) {
            case 1: return BsPersonSquare
            case 2: return BsPencilSquare
            case 3: return BsUnlock
            default: return BsPersonSquare
        }
    }

    const switchProfileMenu = () => {
        switch (menu) {
            case 1: return <ProfileInfo />
            case 2: return <ProfileEdit />
            case 3: return <ProfileEditPassword />
            default: return (<Text>Not Found</Text>)
        }
    }

    return (
        <Flex p="40px" direction="column" w="full">
            <BlockContainer>
                <BlockHeader title={headerName()} icon={headerIcon()}>
                    <HStack spacing={2}>
                        <Button leftIcon={<BsPersonSquare />} colorScheme="blue" size="sm" variant="outline" onClick={() => setMenu(1)}>ข้อมูล</Button>
                        <Button leftIcon={<BsPencilSquare />} colorScheme="yellow" size="sm" variant="outline" onClick={() => setMenu(2)}>แก้ไขข้อมูล</Button>
                        <Button leftIcon={<BsUnlock />} colorScheme="red" size="sm" variant="outline" onClick={() => setMenu(3)}>แก้ไขรหัสผ่าน</Button>
                    </HStack>
                </BlockHeader>
                <Divider />
                <Flex w="full" pt={5} >
                    {switchProfileMenu()}
                </Flex>
            </BlockContainer>
        </Flex>
    )
}

export default Profile